import React from 'react'
import { Route, Switch } from 'react-router'
import Home from './components/pages/Home'
import Mentor from './components/pages/Mentor'
import Login from './components/pages/Login'
import Register from './components/pages/Register'
import StudentPage from './components/pages/StudentPage'




function App() {
      return (
        <div className="App">
           <Switch>
             <Route path='/'exact >
                <Home/>
             </Route>
             <Route path='/Mentor' exact>
                <Mentor/>
             </Route>
             <Route path='/SignIn' exact>
                <Login/>
             </Route>
             <Route path='/SignUp' exact>
                <Register/>
             </Route>
             <Route path='/Dashboard' exact>
                <StudentPage/>
             </Route>
           </Switch>
          
        </div>
      );
}

export default App;
